interface Named {
  name: string;
}

export function namedSort<T extends Named[]>(array: T): T {
  return array.sort((a, b) => (a.name < b.name ? -1 : 1));
}
